import Article from './article.factory'
import ArticleListService from './article-list.service'

const module = angular.module('ac.repositories.article', [])

module.factory('Article', Article).service('ArticleListService', ArticleListService)

export default module.name
